"use client"

import { CassetteTape } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CassetteTapeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CassetteTapeIcon = component(Icon)({ as: CassetteTape })
